import React, { useState } from "react";
import Select from "react-select";
import { FiEdit } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import DashLayout from "../../layouts/DashLayout";
import Overlay from "../../components/Overlay";
import { style } from "../../styles/Style";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getFunds, addnewFund } from "../../store/actions/FundActions";
import { getFundTypes } from "../../store/actions/FundTypesActions";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";

function Funds() {
  const dispatch = useDispatch();
  //  declararation funds

  const [fund, setFund] = useState({
    id: "",
    createdAt: "",
    fundType: {
      idValue: "",
    },
    name: "",
    fundDescription: "",
  });
  // call funds reducer
  const funds = useSelector((state) => state.fundsState.funds);
  const fundsTypes = useSelector((state) => state.fundsTypes);
  const loaders = useSelector((state) => state.loadersState);

  // handle  submisison
  const handleFundSubmit = (e) => {
    e.preventDefault();
    const newFund = {
      ...fund,
      createdAt: new Date(),
    };
    dispatch(addnewFund(newFund, closeFundFormAfterAdding));
  };

  const [addFundsOvellay, openAddFundsOvellay] = useState(0);
  function fundsOvellayController() {
    openAddFundsOvellay(!addFundsOvellay);
  }
  // update reducers after effect
  useEffect(() => {
    dispatch(getFunds());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getFundTypes());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // funds select option
  const fundTypesOption = [];
  for (let i = 0; i < fundsTypes.length; i++) {
    const type = {
      value: fundsTypes[i].id,
      label: fundsTypes[i].fundName,
    };

    fundTypesOption.push(type);
  }

  function closeFundFormAfterAdding() {
    fundsOvellayController();
    setFund({
      id: "",
      createdAt: "",
      fundType: {
        idValue: "",
      },
      name: "",
      fundDescription: "",
    });
  }

  // console.log(funds);
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      <div className="mx-10 bg-white rounded-md">
        <div className="flex p-10 pl-10 pb-0">
          <h2 className="font-semibold">Funds and gifts</h2>
          <div className="m-auto mr-0">
            <button
              className="p-2 rounded-md text-white bg-indigo-500 hover:bg-indigo-400"
              onClick={() => {
                fundsOvellayController();
              }}
            >
              <FiEdit />
            </button>
          </div>
        </div>
        <div className="border-b pb-5 mx-10 border-gray-100" />
        <div className="flex flex-col pl-10 py-5 pr-10">
          {!loaders.fund.fetchingLoaders ? (
            (!loaders.fund.fetchingLoaders && funds.length < 1) |
            loaders.fund.fetchFailedMessage ? (
              <div
                className={
                  !loaders.fund.fetchFailedMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.fund.fetchFailedMessage
                    ? "No fund found"
                    : loaders.fund.fetchFailedMessage}
                </p>
              </div>
            ) : (
              funds?.map((mappedFund, i) => {
                return (
                  <Link key={i} to={"/services/funds/" + mappedFund.id}>
                    <div className="flex flex-col md:flex-row py-4 border-l-4 my-2 border rounded rounded-l-none border-gray-200 hover:border-gray-200 border-l-indigo-500 cursor-pointer bg-white hover:bg-gray-50">
                      <div className="px-2 font-semibold">
                        {i + 1}. <span className="mx-1">{mappedFund.name}</span>
                      </div>
                      <div className="my-1 md:my-auto  md:bg-gray-100 text-gray-500 rounded-md px-2">
                        {mappedFund.fundType.fundName}
                      </div>
                      {/* <div className="md:m-auto ml-2 md:mr-5 text-indigo-500 bg-indigo-100  border border-indigo-100 px-2 rounded-md fit-content">
                        {Funds.attendees.length}
                        {" received it"}
                      </div> */}
                    </div>
                  </Link>
                );
              })
            )
          ) : (
            <div className="spinner m-auto indigo-spinner">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          )}
        </div>
        {/*add Funds overlay  */}
        <div className={addFundsOvellay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="bg-white m-auto  rounded-md">
              <div
                className={
                  loaders.fund.message
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.fund.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {"Register fund or gift"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        return fundsOvellayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <form onSubmit={handleFundSubmit}>
                        <div className="flex flex-col pt-3">
                          {/*  field */}
                          <div className="py-2 w-full">
                            <label>Name </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="text"
                                className={style.field.input}
                                value={fund.name}
                                onChange={(e) =>
                                  setFund({
                                    ...fund,
                                    name: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          {/*  field */}
                          <div className="py-2 w-full">
                            <label>Type </label>
                            <Select
                              options={fundTypesOption}
                              value={fundTypesOption.find(
                                (obj) => obj.value === fund.fundType.idValue
                              )}
                              onChange={(e) =>
                                setFund({
                                  ...fund,
                                  fundType: {
                                    idValue: e.value,
                                  },
                                })
                              }
                            />
                          </div>
                          {/*  field */}
                          {/* <div className="py-2 w-full">
                            <label>Description </label>
                            <div className={style.field.parentDiv}>
                              <textarea
                                className={style.field.input}
                                value={fund.fundDescription}
                                onChange={(e) =>
                                  setFund({
                                    ...fund,
                                    fundDescription: e.target.value,
                                  })
                                }
                              ></textarea>
                            </div>
                          </div> */}

                          {/* save btn */}
                          <button
                            type="submit"
                            className={style.loginBtn}
                            disabled={loaders.fund.sendingLoader}
                          >
                            {!loaders.fund.sendingLoader ? (
                              <p className="m-auto">{"Register"}</p>
                            ) : (
                              <div className="spinner m-auto">
                                <div className="bounce1"></div>
                                <div className="bounce2"></div>
                                <div className="bounce3"></div>
                              </div>
                            )}{" "}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
      </div>
    </DashLayout>
  );
}

export default Funds;
